module.exports = __webpack_public_path__ + "static/media/manage-block.b6b049f8.png";